(() => {
  if (window.bbNavigationInitialized) return;
  window.bbNavigationInitialized = true;

  const teamAliases = Object.fromEntries("||alabama-crimson-tide=Bama UA||arkansas-razorbacks=Arkansas||arizona-state=ASU||arizona-wildcats=UA Arizona||auburn-tigers=Auburn||baylor-bears=BU||boise-state-broncos=BSU||charlotte-49ers=UNCC UNC Charlotte||clemson-tigers=Clemson||east-carolina=ECU East Carolina||eastern-kentucky=EKU||florida-gators=UF||florida-state=FSU||georgia-bulldogs=UGA||george-mason=GMU||georgia-southern=GSU||georgia-tech=GT||houston-cougars=UH||illinois-illini=UIUC||indiana-university=IU||iowa-hawkeyes=UI||iowa-state=ISU||james-madison=JMU James Madison||kansas-jayhawks=KU||kansas-state=KSU K-State||kentucky-wildcats=UK||louisville-cardinals=UofL||lsu-tigers=LSU Louisiana State||marshall-university=MU||miami-university=Miami Ohio||michigan-state-spartans=MSU||middle-tennessee=MTSU||mississippi-state=MSU||missouri-state-bears=Missouri State||missouri-tigers=Mizzou||naval-academy-midshipmen=USNA Navy||nc-state=NCSU||nebraska-huskers=UNL Cornhuskers||northern-iowa-panthers=UNI||northwestern-wildcats=NU||ohio-state-buckeyes=OSU||ohio-university-bobcats=OU||oklahoma-state-cowboys=OSU||old-dominion-monarchs=ODU||ole-miss=Mississippi||oregon-state-beavers=OSU||purdue-university=Purdue||rutgers-university=RU||south-carolina-gamecocks=USC||southern-miss=USM||tcu-horned-frogs=Texas Christian||tennessee-vols=UT Volunteers||texas-a-m=TAMU Texas A&M||texas-tech=TTU||utep-miners=Texas El Paso||virginia-cavaliers=UVA||virginia-tech=VT||washington-state-cougars=WSU||west-virginia-mountaineers=WVU||".split('||').filter(Boolean).map((entry) => entry.split('=')));
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  const buildSearchName = (title, destination, keywords = '') => {
    const handle = destination.split(/[?#]/)[0].split('/').filter(Boolean).pop() || '';
    return normalize(`${title} ${handle} ${teamAliases[handle] || ''} ${keywords}`);
  };
  const matchesTeamQuery = (searchName, query) => {
    const words = normalize(query).split(' ').filter(Boolean);
    const terms = searchName.split(' ');
    return words.every((word) => word.length <= 3 ? terms.some((term) => term.startsWith(word)) : searchName.includes(word));
  };

  const initializeDirectory = (directory) => {
    if (directory.dataset.bbInitialized) return;
    directory.dataset.bbInitialized = 'true';
    const input = directory.querySelector('[data-bb-team-search]');
    const items = [...directory.querySelectorAll('[data-bb-team]')];
    const count = directory.querySelector('[data-bb-team-count]');
    const empty = directory.querySelector('[data-bb-team-empty]');
    const toggle = directory.querySelector('[data-bb-team-expand]');
    const initialCount = Number(directory.dataset.initialCount) || 8;
    const compact = directory.dataset.mode === 'compact';
    let expanded = !compact;
    const initialCountText = count.textContent;
    const names = new Map(items.map((item) => {
      const link = item.querySelector('a');
      return [item, buildSearchName(link.textContent, link.getAttribute('href') || '', item.dataset.bbTeamKeywords || '')];
    }));

    const update = () => {
      const query = normalize(input.value);
      let matches = 0;
      items.forEach((item) => {
        const matchesQuery = matchesTeamQuery(names.get(item), query);
        if (matchesQuery) matches += 1;
        item.hidden = !matchesQuery || (!query && !expanded && matches > initialCount);
      });
      count.textContent = query ? directory.dataset.countLabel.replace('[count]', String(matches)) : initialCountText;
      empty.hidden = matches !== 0;
      if (toggle) {
        toggle.hidden = !compact || Boolean(query) || items.length <= initialCount;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.replaceChildren(document.createTextNode(expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore));
        const mark = document.createElement('span');
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = expanded ? '−' : '+';
        toggle.append(mark);
      }
    };

    input.addEventListener('input', update);
    input.addEventListener('search', update);
    toggle?.addEventListener('click', () => {
      expanded = !expanded;
      update();
    });
    update();
  };

  const initializeNavigation = (navigation) => {
    if (navigation.dataset.bbInitialized) return;
    navigation.dataset.bbInitialized = 'true';
    const disclosures = [...navigation.querySelectorAll('[data-bb-nav-details]')];
    disclosures.forEach((disclosure) => {
      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) return;
        disclosures.forEach((other) => {
          if (other !== disclosure) other.open = false;
        });
      });
    });
    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = disclosures.find((disclosure) => disclosure.open);
      if (!open) return;
      event.preventDefault();
      open.open = false;
      open.querySelector('summary').focus();
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-bb-team-directory]').forEach(initializeDirectory);
    root.querySelectorAll('[data-bb-shop-nav]').forEach(initializeNavigation);
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-bb-shop-nav]').forEach((navigation) => {
      if (!navigation.contains(event.target)) {
        navigation.querySelectorAll('[data-bb-nav-details][open]').forEach((disclosure) => { disclosure.open = false; });
      }
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-bb-shop-nav]').forEach((navigation) => {
      if (!navigation.contains(event.target)) {
        navigation.querySelectorAll('[data-bb-nav-details][open]').forEach((disclosure) => { disclosure.open = false; });
      }
    });
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
